import React from 'react';
import style from './style.scss';

import AppStore from '../app-store-badge';

export default () => (
  <div className="appPromptBar slideUp">
    <div className="badgeWrapper">
      <AppStore/>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/app-prompt/index.js